export const SPACE_MARGIN_FOR_HEADER = 152;
export const SPACE_SIDEBAR_WIDTH = {
  OPEN: 220,
  MINIMIZED: 80,
} as const;
